import React, { Component } from "react";
import { VictoryBar, VictoryAxis, VictoryChart, VictoryTheme, VictoryTooltip } from "victory";
import { instantFromApi } from "../utils/dateTime";
import { createRedToGreenColor } from "../utils/colorUtils";

const GROUP_COUNT = 60;

class TradesDurationChart extends Component {
  prepareData(trades) {
    const { botConfig } = this.props;
    const forceSellMins = botConfig.forceSellAfterMinutes ? botConfig.forceSellAfterMinutes : 1000; // FIXME 1000 ???

    let categoryTresholdMins = parseInt((forceSellMins / GROUP_COUNT).toFixed(0), 10);
    categoryTresholdMins = categoryTresholdMins >= 1 ? categoryTresholdMins : 1;

    const profitByCategory = new Map();

    const tradeGroups = trades.reduce((acc, trade) => {
      const openInstant = instantFromApi(trade.openDate);
      const closeInstant = instantFromApi(trade.closeDate);
      const diffMinutes = closeInstant.minusSeconds(openInstant.epochSecond()).epochSecond() / 60;

      // every categoryTresholdMins minutes there is a category
      let category = parseInt((diffMinutes / categoryTresholdMins).toFixed(0), 10);
      if (category >= GROUP_COUNT) {
        category = GROUP_COUNT - 1;
      }

      let profitCount = profitByCategory.get(category);
      profitCount = profitCount ? profitCount : 0;

      profitByCategory.set(category, trade.profitTotal > 0 ? profitCount + 1 : profitCount);

      let val = acc.get(category);

      acc.set(category, val ? val + 1 : 1);

      return acc;
    }, new Map());

    const tradesCount = trades.length;
    let tradesCountAccumulator = 0;
    const result = [];

    result.push({
      x: 0,
      y: 0,
      y0: 0,
    });

    for (let i = 0; i < GROUP_COUNT; i++) {
      const value = tradeGroups.get(i);
      tradesCountAccumulator += value ? value : 0;

      let labelValue = null;
      if (value) {
        if (i + 1 === GROUP_COUNT) {
          // the last group
          labelValue =
            "Group < " +
            (i + 1) * categoryTresholdMins +
            "m\n \n" +
            (100 * (value / tradesCount)).toFixed(0) +
            "% of all closed trades\n" +
            "In profit: " +
            profitByCategory.get(i) +
            "/" +
            value;
        } else {
          labelValue =
            "Group < " +
            (i + 1) * categoryTresholdMins +
            "m\n \n" +
            "Percentile: " +
            (100 * (tradesCountAccumulator / tradesCount)).toFixed(0) +
            "%\n" +
            "In profit: " +
            profitByCategory.get(i) +
            "/" +
            value;
        }
      }

      result.push({
        x: (i + 1) * categoryTresholdMins,
        y: value ? value : 0,
        y0: 0,
        label: labelValue,
      });
    }

    return result;
  }

  static calculatePct(value, max) {
    return value / max * 100;
  }

  render() {
    if (!this.props.trades) return null;

    const { botConfig } = this.props;
    const forceSellMins = botConfig.forceSellAfterMinutes;

    return (
      <VictoryChart width={1400} height={400} theme={VictoryTheme.material}>
        <VictoryAxis dependentAxis label="Trade count" style={{ axisLabel: { padding: 40 } }} />
        <VictoryAxis label="Duration (m)" tickCount={20} style={{ axisLabel: { padding: 30 } }} />
        <VictoryBar
          style={{
            data: {
              fill: d => {
                let pct = TradesDurationChart.calculatePct(d.x, forceSellMins);
                pct = pct > 100.0 ? 100.0 : pct;
                return createRedToGreenColor(100.0 - pct);
              },
              fillOpacity: 0.7,
            },
          }}
          data={this.prepareData(this.props.trades)}
          alignment={"end"}
          width={200}
          labelComponent={<VictoryTooltip dx={-5} />}
          events={[
            {
              target: "data",
              eventHandlers: {
                onMouseOver: () => {
                  return [
                    {
                      target: "data",
                      mutation: d => ({ style: { fill: d.style.fill } }), // return a new style object without fillOpacity
                    },
                    {
                      target: "labels",
                      mutation: () => ({ active: true }),
                    },
                  ];
                },
                onMouseOut: () => {
                  return [
                    {
                      target: "data",
                      mutation: () => {},
                    },
                    {
                      target: "labels",
                      mutation: () => ({ active: false }),
                    },
                  ];
                },
              },
            },
          ]}
        />
      </VictoryChart>
    );
  }
}

export default TradesDurationChart;



// WEBPACK FOOTER //
// ./src/charts/TradesDurationChart.js